export const getPaymentMethods = async (axios, includeNonCC) =>
  (
    await axios.get(
      `/api/payment/card/?include_non_cc=${includeNonCC ? 'true' : 'false'}`,
    )
  ).data

export const submitNewPaymentMethod = async (axios, data) => {
  try {
    return await axios.post('/api/payment/card/', data)
  } catch (e) {
    console.error(e)
    throw e
  }
}

export const getCard = async ($axios, cardId) => {
  try {
    return await $axios.get(`/api/payment/card/${cardId}/`)
  } catch (e) {
    console.error(`Failed fetching card ${cardId}`, e)
    throw e
  }
}

export const updateCard = async ($axios, cardId, data) => {
  // Takes data from a hosted field tokenize call to update our own data
  data.payment_method_nonce = data.token
  delete data.token
  try {
    return await $axios.put(`/api/payment/card/${cardId}/`, data)
  } catch (e) {
    console.error(`Failed updating card ${cardId}`, e)
    throw e
  }
}
